<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardContent
        :cardContent="content"
        :cardTypeProps="cardTypeProps"
        @nextRoute="nextRoute"
        :soundOBJ="soundObject"
      />
    </template>
  </div>
</template>
<script>
import CardContent from '../../../components/template/Chinese1/CardContent';
import CardPopupImg from '../../../components/template/Chinese1/CardPopupImg';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardContent, CardPopupImg, LoadingMDL},
  name: 'CTA05',
  data() {
    return {
      cardTypeProps: true,
      content: {},
      lang: this.$store.getters['language/getLanguage'],
      baseURL: 'CTA05-',
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      soundObject: [],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      courseSection: '',
      startTime: '',
      condition: [],
      courseId: '',
      loading: true,
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }
      var data = this.content.content.page[0].paragraph;

      for (let i = 0; i < data.length; i++) {
        this.soundObject.push(new Audio(this.baseUrl + data[i].line[0].class));
      }

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'CTA05 save Content watcher');
      if (this.nextPath) {
        this.loading = true;
        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;

        this.$router.push(onNext);
      }
    },

    storeLanguage: function (val) {
      this.lang = val;
    },
    '$route.params.id'() {
      this.onLoadData();
    },
  },

  mounted() {
    this.onLoadData();
  },

  created() {
    this.courseCode = this.$store.getters['necessary/getLerningCourse'].code;
    this.courseId = this.$store.state.necessary.learningCourse;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    onLoadData() {
      this.loading = true;

      const contentId = `CTA05-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    nextRoute(path) {
      if (path.type == 0 || path.type == null) {
        this.goBack(path.path);
      } else if (path.type == 1) {
        this.linkNextTo(path.path);
      }
    },
    linkNextTo(path) {
      this.commitPayloadData(path);
    },
    goBack(path) {
      let str = path.split('-');
      this.$router.push(`/v4/${str[0]}/${str[1]}`);
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];

      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
};
</script>
<style></style>
